export const NAV_GROUP_CONTENT_SESSIONS = "Content & sessions";
export const NAV_GROUP_ACCESS_MANAGEMENT = "Access";
export const NAV_GROUP_SESSION = "Session";
export const NAV_GROUP_PATH = "Path";
export const NAV_GROUP_STATS = "Stats";
export const NAV_GROUP_RANKINGS = "Rankings";
export const NAV_GROUP_ADMIN = "Admin";
